export default __webpack_public_path__ + "static/media/ffbrave-exius.6c629c55.jpg";